<p>add-chart works!</p>
